import _enUS from '../en-US/paymentServiceList.json'
import _zhHK from '../zh-HK/paymentServiceList.json'
import _zhCN from '../zh-CN/paymentServiceList.json'
import commonUS from '../en-US/common.json'
import commonHK from '../zh-HK/common.json'
import commonCN from '../zh-CN/common.json'

const enUS = { ...commonUS, ..._enUS }
const zhHK = { ...commonHK, ..._zhHK }
const zhCN = { ...commonCN, ..._zhCN }

export default { enUS, zhHK, zhCN }
